@for (footnote of footnotes(); track footnote.marker) {
  <p class="text--very-small" [attr.id]="footnote.kind === 'DYNAMIC_ANNUAL' ? 'dynamicPriceInfo' : null">
    <sup>{{ footnote.marker }}</sup> {{ footnote.text }}
  </p>
}
